export default __webpack_public_path__ + "static/media/Basketball.f461a761.jpg";